import IcDownload from './IcDownload'
export default IcDownload
